const getters = {
  index: state => state.data.index,
  loading: state => state.setting.loading
}

export default getters
